export interface UsageStatsRequest {
    organizationId: number;
    startDate: Date;
    endDate?: Date;
    language: string;
    format: ReportFormat
}

export interface SubscriptionsExpirationRequest {
    startDate: Date;
    endDate: Date;
    format: ReportFormat
}

export interface DeviceActivationRequest {
    format: ReportFormat
}

export enum ReportFormat {
    JSON = "json",
    SPREADSHEET = "spreadsheet"
}
